<dl class="messages-list">
    <ng-container *ngIf="showFieldKeys">
        <ng-container *ngFor="let controlName of getControlNames()">
            <dt
                *ngIf="
                showFieldName &&
                (getMessagesForField(controlName).length > 0 ||
                getFieldErrors(controlName).length > 0)
                "
                class="control-name"
                >
                {{ controlName }}
            </dt>
            <ng-container *ngIf="getFieldErrors(controlName).length > 0">
                <dd class="error-messages">
                    <ul>
                        <li *ngFor="let message of getFieldErrors(controlName)" class="error-message">
                            {{ message | translate }}
                        </li>
                    </ul>
                </dd>
            </ng-container>
            <ng-container *ngIf="getMessagesForField(controlName).length > 0">
                <dd class="success-messages">
                    <ul>
                        <li *ngFor="let message of getMessagesForField(controlName)" class="success-message">
                            {{ message | translate }}
                        </li>
                    </ul>
                </dd>
            </ng-container>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="showNonFieldKeys">
        <ng-container *ngFor="let key of getNonFieldKeys()">
            <dt *ngIf="showFieldName" class="non-field-key">{{ key }}</dt>
            <dd class="non-field-messages">
                <ul>
                    <li *ngFor="let message of getMessagesForField(key)" class="non-field-message">
                        {{ message | translate }}
                    </li>
                </ul>
            </dd>
        </ng-container>
    </ng-container>
</dl>